module.exports = __webpack_public_path__ + "assets/img/v2.b9126888.png";